import classes from "./classes.module.scss";
import Link from "next/link";
import { Routes, buildRoute } from "@Front/Config/Routes";
import { ELegalOptions } from "@Front/Components/LayoutTemplates/DefaultLegalDashboard";
import VerticalSeparator from "@Assets/Icons/vertical-separator.svg";
import Image from "next/image";

type IProps = {
	className?: string;
};

export default function Mobile({ className }: IProps): React.ReactElement {
	const legalPagesBase = Routes.pages.Legal.LegalInformations;
	return (
		<div className={[classes["sub-root"], className].join(" ")}>
			<Link href={buildRoute(legalPagesBase, { legalUid: ELegalOptions.LEGAL_MENTIONS })}>© Copyright lecoffre 2026</Link>
			<Image src={VerticalSeparator} alt="Separator" />
			<Link href={buildRoute(legalPagesBase, { legalUid: ELegalOptions.LEGAL_MENTIONS })}>Juridiques</Link>
			<Image src={VerticalSeparator} alt="Separator" />
			<Link href={buildRoute(legalPagesBase, { legalUid: ELegalOptions.POLITIQUE_DE_GESTION_DES_COOKIES })}>Cookies</Link>
		</div>
	);
}
